import { render, staticRenderFns } from "./AccordionSelectGroup.vue?vue&type=template&id=490ea34c&scoped=true"
import script from "./AccordionSelectGroup.vue?vue&type=script&lang=js"
export * from "./AccordionSelectGroup.vue?vue&type=script&lang=js"
import style0 from "./AccordionSelectGroup.vue?vue&type=style&index=0&id=490ea34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ea34c",
  null
  
)

export default component.exports